package com.essntl.features.qbauth.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.qbauth.data")
class QbAuthModule
